import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-leftAligned",
  "use": "icon-leftAligned-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-leftAligned\"><path d=\"M153.6 102.4h51.2v819.2h-51.2V102.4zM256 204.8h409.6v256H256v-256zM819.2 563.2V768h-512V563.2h512m51.2-51.2H256v307.2h614.4V512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol